var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentParcialD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 193,
    viewBox: "0 0 110 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.23 51.44L30 7.71999L17.55 0.48999V14.88V134.4V139.16L21.67 141.56L96.91 185.28L109.35 192.51V178.12V58.6V53.84L105.23 51.44Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.07 58.6L25.84 14.88V134.4L101.07 178.12V58.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.07 166.11L97.71 164.16L101.07 178.12V166.11Z",
    fill: "#DDDDDF",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.81 20.68L25.84 14.88V42.67L35.81 48.47V20.68Z",
    fill: "#A6A6A7",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 134.4L35.81 128.18V48.47L25.84 42.67V122.39V134.4Z",
    fill: "#A6A6A7",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 114.89L25.84 111.66V116.62L22.23 119.1L21.21 114.89Z",
    fill: "#A6A6A7",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.81 128.18L25.84 134.4L35.81 140.19L101.07 178.12L97.71 164.16L35.81 128.18Z",
    fill: "#DDDDDF",
    stroke: "#666666",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.83 156.31L101.07 152.64V157.61L96.84 160.51L95.83 156.31Z",
    fill: "#A6A6A7",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.88 71.76L0.649994 28.04L25.84 134.4L101.07 178.12L75.88 71.76Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 14.88V42.67L75.88 71.76L101.07 178.12V58.6L25.84 14.88Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.13 115.22L76.37 120.37C76.4572 120.736 76.6388 121.073 76.8967 121.346C77.1547 121.62 77.4799 121.821 77.84 121.93L79.45 122.41C79.6478 122.468 79.8572 122.473 80.0575 122.424C80.2578 122.376 80.4419 122.276 80.5916 122.135C80.7412 121.993 80.8512 121.815 80.9106 121.617C80.97 121.42 80.9767 121.211 80.93 121.01L79.81 116.37C79.7159 115.966 79.5164 115.594 79.2319 115.292C78.9473 114.989 78.5879 114.768 78.19 114.65L76.33 114.09C76.1714 114.056 76.0069 114.06 75.8506 114.104C75.6942 114.147 75.5508 114.228 75.4327 114.339C75.3146 114.451 75.2253 114.589 75.1726 114.742C75.1198 114.896 75.1052 115.06 75.13 115.22Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.08 97.71C71 103.45 72.88 111.3 74.95 116.64C75.1083 117.013 75.3501 117.346 75.657 117.611C75.9639 117.876 76.3276 118.067 76.72 118.17L78.49 118.66C79.49 118.92 80.17 118.21 79.8 117.37C77.59 112.26 75.5 104.64 75.3 99.09C75.3031 98.7019 75.1931 98.3213 74.9836 97.9945C74.7741 97.6678 74.474 97.4091 74.12 97.25L72.5 96.59C72.3309 96.5511 72.1552 96.5506 71.9858 96.5887C71.8165 96.6267 71.6579 96.7022 71.5216 96.8097C71.3853 96.9172 71.2749 97.0539 71.1985 97.2097C71.1221 97.3655 71.0816 97.5365 71.08 97.71Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentParcialD);
export default __webpack_public_path__ + "static/media/VentParcialD.755553db646fc29408c52fcae45e40b5.svg";
export { ForwardRef as ReactComponent };